'use client';

import React, { useState, useEffect } from 'react';
import { Flex } from '@skin-seoul/design-system';
import { CurrencyIcons } from '@skin-seoul/service';
import type { Country } from '@skin-seoul/service';
import type { ComponentProps } from 'react';
import { CountryChangeModal } from '../CountryChangeModal/CountryChangeModal';
const COUNTRY_BUTTON_TEST_ID = 'country-change-button';
type CountryChangeButtonProps = ComponentProps<typeof Flex> & {
  country: Country;
  onCountryChange?: (country: Country) => void;
  className?: string;
};
export const CountryChangeButton = ({
  country,
  onCountryChange,
  className,
  ...rest
}: CountryChangeButtonProps) => {
  const [currentCountry, setCurrentCountry] = useState<Country>(country);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    setCurrentCountry(country);
  }, [country]);
  const handleClick = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
    if (onCountryChange) {
      onCountryChange(currentCountry);
    }
  };
  return <Flex className={className} data-sentry-element="Flex" data-sentry-component="CountryChangeButton" data-sentry-source-file="CountryChangeButton.tsx">
      <Flex as="button" cursor="pointer" data-testid={COUNTRY_BUTTON_TEST_ID} minWidth="24px" minHeight="24px" border="none" backgroundColor="transparent" padding="0" onClick={handleClick} {...rest} data-sentry-element="Flex" data-sentry-source-file="CountryChangeButton.tsx">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img alt={`${currentCountry} flag`} height={24} width={24} src={CurrencyIcons[currentCountry]} style={{
        borderRadius: '50%',
        display: 'block',
        objectFit: 'cover',
        border: '1px solid #605D66'
      }} loading="lazy" data-country={currentCountry} />
      </Flex>
      <CountryChangeModal initialCountry={currentCountry} isOpen={isModalOpen} onClose={handleModalClose} data-sentry-element="CountryChangeModal" data-sentry-source-file="CountryChangeButton.tsx" />
    </Flex>;
};